import { type Mark } from '../../Form/RangeSlider/types.ts';

// The find will never not return a Mark
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const findMarkByLabel = (mappings: Mark[], label: string): Mark => mappings.find(mapping => mapping.label === label)!;

export const swapLabelsWithValues = (labels: string[], mappings: Mark[]) =>
  labels.map(label => findMarkByLabel(mappings, label).value);
